import dotProp from 'dot-prop-immutable';
import {
  RBI_SET_STORES,
  RBI_SET_SELECTED_STORE,
  RBI_SET_STORE_LOCATION_QUERY,
  RBI_CLEAR_STATE,
} from 'constants/rbiActionTypes';

const INITIAL_STATE = { rbiStoreLocations: [], selectedStore: null, storeLocationQuery: null };

// TODO Move RBI specific actions into this folder
const rbi = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RBI_SET_STORES:
      return dotProp.set(state, 'rbiStoreLocations', action.stores);
    case RBI_SET_SELECTED_STORE:
      return dotProp.set(state, 'selectedStore', action.store);
    case RBI_SET_STORE_LOCATION_QUERY:
      return dotProp.set(state, 'storeLocationQuery', action.query);
    case RBI_CLEAR_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default rbi;
